import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getCategories = () => axios.get(`${API}/academy/categories`).then((r) => r.data);
export const getVideos = () => axios.get(`${API}/academy/videos`).then((r) => r.data);
export const getArticle = (slug) => axios.get(`${API}/academy/articles/${slug}`).then((r) => r.data);
export const getArticles = (params = {}) =>
  axios.get(`${API}/academy/articles`, { params }).then((r) => r.data);

// Brand accent classes (orange / amber / red — no blue)
export const ACCENTS = {
  orange: {
    text: 'text-orange-400',
    grad: 'from-orange-500 to-orange-600',
    glow: 'bg-orange-500/25',
    border: 'border-orange-500/40',
    hoverBorder: 'group-hover:border-orange-500/70',
    chip: 'bg-orange-500/10 text-orange-300 border-orange-500/30',
    dot: 'bg-orange-500',
  },
  amber: {
    text: 'text-amber-400',
    grad: 'from-amber-400 to-amber-600',
    glow: 'bg-amber-500/25',
    border: 'border-amber-500/40',
    hoverBorder: 'group-hover:border-amber-500/70',
    chip: 'bg-amber-500/10 text-amber-300 border-amber-500/30',
    dot: 'bg-amber-500',
  },
  red: {
    text: 'text-red-400',
    grad: 'from-red-500 to-rose-600',
    glow: 'bg-red-500/25',
    border: 'border-red-500/40',
    hoverBorder: 'group-hover:border-red-500/70',
    chip: 'bg-red-500/10 text-red-300 border-red-500/30',
    dot: 'bg-red-500',
  },
};

export const CATEGORY_META = {
  'buying-guides': { name: 'Buying Guides', accent: 'orange' },
  'local-guides': { name: 'Local Guides', accent: 'orange' },
  'inspection-education': { name: 'Inspection Education', accent: 'amber' },
  'vehicle-history': { name: 'Vehicle History', accent: 'red' },
  'mechanical-basics': { name: 'Mechanical Basics', accent: 'orange' },
  'marketplace-tips': { name: 'Marketplace Tips', accent: 'amber' },
  videos: { name: 'Videos', accent: 'red' },
};
